import { SetApplicationStateAction, SetHasNavigateProdDetailsAction, SetIsActionType } from '@customTypes/ActionTypes';
import { ApplicationFlowType, setHasNavigateProdDetails } from '@customTypes/ItemTypes';

export const SET_COMPANY_REPORT = 'SET_COMPANY_REPORT';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_ERROR = 'SET_IS_ERROR';
export const SET_HAS_NAVIGATE = 'SET_HAS_NAVIGATE';
export const SET_APPLICATION_FLOW_TYPE = 'SET_APPLICATION_FLOW_TYPE';
export const SET_SERVICE_IS_DOWN = 'SET_SERVICE_IS_DOWN';
export const SET_IS_SCREEN_UNDER_600_PIXEL = 'SET_IS_SCREEN_UNDER_600_PIXEL';
export const SET_IS_SCREEN_UNDER_768_PIXEL = 'SET_IS_SCREEN_UNDER_768_PIXEL';

export function setIsMobile(value : boolean) : SetIsActionType {
    return {
        type: SET_IS_MOBILE,
        value
    };
}

export function setIsScreenWidthUnder600Pixel(value : boolean) : SetIsActionType {
    return {
        type: SET_IS_SCREEN_UNDER_600_PIXEL,
        value
    };
}
export function setIsScreenWidthUnder768Pixel(value : boolean) : SetIsActionType {
    return {
        type: SET_IS_SCREEN_UNDER_768_PIXEL,
        value
    };
}

export function setIsError(value : boolean) : SetIsActionType {
    return {
        type: SET_IS_ERROR,
        value
    };
}

export function setHasNavigate(value : setHasNavigateProdDetails) : SetHasNavigateProdDetailsAction {
    return {
        type: SET_HAS_NAVIGATE,
        value
    };
}

export function setServiceIsDown(value : boolean) : SetIsActionType {
    return {
        type: SET_SERVICE_IS_DOWN,
        value
    };
}

export function setIsLoading(value : boolean) : SetIsActionType {
    return {
        type: SET_IS_LOADING,
        value
    };
}

export function setApplicationState(value : ApplicationFlowType) : SetApplicationStateAction {
    return {
        type: SET_APPLICATION_FLOW_TYPE,
        value
    };
}
